const createQueryParameters = (parameters) => {
  if (!parameters) {
    return "";
  }
  const queryString = typeof parameters === "string" ? parameters : new URLSearchParams(parameters).toString();
  return queryString ? `?${queryString}` : "";
};
export { createQueryParameters };
